import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { FAQS } from '../mock';

export default function FAQ() {
  return (
    <section className="bg-[#f5f5f7] py-24 md:py-28">
      <div className="max-w-[900px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4 text-center">NAJCZĘSTSZE PYTANIA</div>
        <h2 className="font-heading font-extrabold text-[38px] md:text-[48px] leading-[1.05] tracking-tight text-[#0f1a2b] text-center">
          Pytania i odpowiedzi
        </h2>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="rounded-xl bg-white border border-slate-200 px-6 data-[state=open]:shadow-sm">
              <AccordionTrigger className="text-left font-heading font-bold text-[16px] tracking-tight text-[#0f1a2b] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[14px] leading-relaxed text-[#0f1a2b]/75 pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
